var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FMP_WRAPPER",style:(_vm.wrapperStyles)},[_c('div',{staticClass:"FMP",style:(_vm.styles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }